import { Flex, Text } from "@fluentui/react-northstar";
import { Card, Empty, Progress } from "antd";
import React from "react";
import Chart from "react-apexcharts";

const RubricCriteriaPerformance = ({
  rubricPerformance = {
    criteria: [
      {
        label: "Content Mastery",
        value: 78,
        description: "Understanding and application of core concepts",
      },
      {
        label: "Critical Thinking",
        value: 65,
        description: "Analysis and evaluation of information",
      },
      {
        label: "Organization & Structure",
        value: 82,
        description: "Logical flow and coherent presentation",
      },
      {
        label: "Evidence & Support",
        value: 71,
        description: "Use of relevant examples and citations",
      },
      {
        label: "Language & Mechanics",
        value: 89,
        description: "Grammar, spelling, and writing style",
      },
    ],
    summary: {
      highestPerforming: "Language & Mechanics",
      needsImprovement: "Critical Thinking",
    },
  },
}) => {
  const { criteria } = rubricPerformance;
  const options = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      radar: {
        polygons: {
          strokeColors: "#e8e8e8",
          fill: {
            colors: ["#f8fafc", "#f0f9ff"],
          },
        },
      },
    },
    colors: ["#6264a7"],
    stroke: {
      width: 2,
    },
    fill: {
      opacity: 0.2,
    },
    markers: {
      size: 4,
      colors: ["#fff"],
      strokeColors: ["#6264a7"],
      strokeWidth: 2,
    },
    yaxis: {
      show: true,
      min: 0,
      max: 100,
      tickAmount: 5,
    },
    xaxis: {
      categories: criteria.map((item) => item.label),
    },
  };

  const series = [
    {
      name: "Performance",
      data: criteria.map((item) => item.value),
    },
  ];

  return (
    <Card
      title={"Rubric Criteria Performance"}
      // extra={
      //   <Space>
      //     <Select
      //       size="small"
      //       defaultValue="By Department"
      //       style={{ width: 120 }}
      //     >
      //       <Option>By Department</Option>
      //       <Option>By Course</Option>
      //       <Option>By Assignment</Option>
      //     </Select>
      //     <a href="#">Compare</a>
      //   </Space>
      // }
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: 420,
        borderRadius: "8px",
        height: "100%",
      }}
      className="shadow"
      bodyStyle={{ height: "100%", flexGrow: 1 }}
    >
      {rubricPerformance?.criteria.length ? (
        <>
          <Text type="secondary" style={{ marginBottom: 16, display: "block" }}>
            Average scores by rubric dimension
          </Text>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 16,
            }}
          >
            <Chart
              options={options}
              series={series}
              type="radar"
              height={320}
            />
          </div>

          <Flex
            hAlign="center"
            vAlign="center"
            gap="gap.smaller"
            style={{ marginBottom: 16 }}
          >
            <div
              style={{
                width: 16,
                height: 8,
                backgroundColor: "#6264a7",
                borderRadius: 2,
              }}
            />
            <Text type="secondary">Current Performance</Text>
          </Flex>

          <Flex gap="gap.smaller" vAlign="center">
            <div
              style={{
                width: 8,
                height: 8,
                backgroundColor: "#ef4444",
                borderRadius: "50%",
              }}
            />
            <Text type="secondary">
              {"Lowest : "}
              {
                criteria.reduce((min, item) =>
                  item.value < min.value ? item : min
                ).label
              }{" "}
              (
              {
                criteria.reduce((min, item) =>
                  item.value < min.value ? item : min
                ).value
              }
              %)
            </Text>
          </Flex>
        </>
      ) : (
        <Flex vAlign="center" hAlign="center" style={{ height: "100%" }}>
          <Empty />
        </Flex>
      )}
    </Card>
  );
};

export default RubricCriteriaPerformance;
